import { type ServerActionResponse } from '@shared/utils/types/server-action';

export class FetchError extends Error {
  public messageTranslationKey?: string;

  public status?: number;

  constructor(errorData: ServerActionResponse) {
    super(errorData.message);
    this.messageTranslationKey = errorData.messageTranslationKey;
    this.status = errorData.status;
  }
}

export class ValidationError extends FetchError {
  constructor({ message, messageTranslationKey, status }: ServerActionResponse) {
    super({ message, messageTranslationKey, status: status ?? 400 });
    this.name = this.constructor.name;
  }
}

export class NotFoundError extends FetchError {
  constructor(message = 'Resource not found') {
    super({ message, messageTranslationKey: 'error.notFound', status: 404 });
    this.name = this.constructor.name;
  }
}

export class NotAuthenticated extends FetchError {
  constructor(message = 'Not authenticated') {
    super({ message, messageTranslationKey: 'error.notAuthenticated', status: 401 });
    this.name = this.constructor.name;
  }
}

export class NotAuthorized extends FetchError {
  constructor(message = 'Not authorized') {
    super({ message, messageTranslationKey: 'error.notAuthorized', status: 403 });
    this.name = this.constructor.name;
  }
}

export class InternalServerError extends FetchError {
  constructor(message = 'Internal server error') {
    super({ message, messageTranslationKey: 'error.internalServer', status: 500 });
    this.name = this.constructor.name;
  }
}
